import { CurrencyDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCurrency = createAction('[Currency] Load Currency');

export const loadCurrencySuccess = createAction(
  '[Currency] Load Currency Success',
  props<{ currency: CurrencyDto[] }>()
);

export const loadCurrencyFailure = createAction(
  '[Currency] Load Currency Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCurrency = createAction(
  '[Currency] Add Currency',
  props<{ newCurrency: CurrencyDto[] }>()
);

export const addCurrencySuccess = createAction(
  '[Currency] Add Currency Success',
  props<{ newCurrency: CurrencyDto[] }>()
);

export const addCurrencyFailure = createAction(
  '[Currency] Add Currency Failure',
  props<{ error: any }>()
);

/**
 * Update Currency Collection Actions
 */
export const updateCurrency = createAction(
  '[Currency] Update Currency',
  props<{ updateCurrency: CurrencyDto[] }>()
);

export const updateCurrencySuccess = createAction(
  '[Currency] Update Currency Success',
  props<{ updateCurrency: CurrencyDto[] }>()
);

export const updateCurrencyFailure = createAction(
  '[Currency] Update Currency Failure',
  props<{ error: any }>()
);

/**
 * Remove Currency Collection Actions
 */
export const removeCurrency = createAction(
  '[Currency] Remove Currency',
  props<{ ids: string[] }>()
);

export const removeCurrencySuccess = createAction(
  '[Currency] Remove Currency Success',
  props<{ ids: string[] }>()
);

export const removeCurrencyFailure = createAction(
  '[Currency] Remove Currency Failure',
  props<{ error: any }>()
);
